import { FormerMemberInvestmentStatements } from '../../../../former-member/components/FormerMemberInvestmentStatements';

export default function FormerMemberInvestmentStatementsPage() {
    return <FormerMemberInvestmentStatements />;
}
